export const defaultTheme = [
    {
        name: '深色系',
        id: 'defaultTheme001',
        type: 1,
        content: [
            // {
            //     title: '字体',
            //     option: [],
            //     field: 'textFamily'
            // },
            {
                title: '字体颜色',
                color: '#ffffff',
                field: 'textColor'
            },
            {
                title: '标题颜色',
                color: '#ffffff',
                field: 'title.textStyle.color'
            },
            {
                title: 'x轴线颜色',
                color: '#02438e',
                field: 'xAxis.axisLine.lineStyle.color'
            },
            {
                title: 'y轴线颜色',
                color: '',
                field: 'yAxis.axisLine.lineStyle.color'
            },
            {
                title: 'x轴字体颜色',
                color: '#6aa9e4',
                field: 'xAxis.axisLabel.color'
            },
            {
                title: 'y轴字体颜色',
                color: '#6aa9e4',
                field: 'yAxis.axisLabel.color'
            },
            // {
            //     title: '图例字体颜色',
            //     color: '#6aa9e4',
            //     field: 'legend.textStyle.color'
            // },

            
        ]
    },
    {
        name: '浅色系',
        id: 'defaultTheme002',
        type: 1,
        content: [
            // {
            //     title: '字体',
            //     option: [],
            //     field: 'textFamily'
            // },
            {
                title: '字体颜色',
                color: '#5d6b81',
                field: 'textColor'
            },
            {
                title: '标题颜色',
                color: '#203453',
                field: 'title.textStyle.color'
            },
            {
                title: 'x轴线颜色',
                color: '#8695a6',
                field: 'xAxis.axisLine.lineStyle.color'
            },
            {
                title: 'y轴线颜色',
                color: '',
                field: 'yAxis.axisLine.lineStyle.color'
            },
            {
                title: 'x轴字体颜色',
                color: '#5d6b81',
                field: 'xAxis.axisLabel.color'
            },
            {
                title: 'y轴字体颜色',
                color: '#5d6b81',
                field: 'yAxis.axisLabel.color'
            }
        ]
    }

]